module.exports = __webpack_public_path__ + "fonts/SFUIText-SemiboldItalic.d40302b2.eot";